import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectHomeData, selectSpeedFormationSave, selectSpeedFormationDate } from '@/containers/HomePage/HomeSelectors'
import { setIsEditingSpeedFormation, setSpeedFormationDate } from '@/containers/HomePage/HomeSlice'
import { homeActions } from '@/containers/HomePage/HomeSagas'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { hasSpeedFormationDueDate } from '@/containers/HomePage/SpeedFormation/hasSpeedFormationDueDate'
import pickedDayAsIso from '@/shared/tools/pickedDayAsIso'

const tomorrow = () => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
}

const savedDateOf = date => {
  const saved = date ? new Date(date) : null
  return saved && !Number.isNaN(saved.getTime()) ? saved : null
}

const useFormationForm = () => {
  const dispatch = useDispatch()
  const { speedFormation } = useSelector(selectHomeData)
  const { isLoading, error, errorMessage } = useSelector(selectSpeedFormationSave)
  const date = useSelector(selectSpeedFormationDate)
  const { country } = useSelector(selectAuthData)
  const hasDueDate = hasSpeedFormationDueDate(country)
  const editorRef = useRef(null)
  const minDueDate = tomorrow()
  const savedDate = savedDateOf(date)
  const pickerDate = savedDate ?? minDueDate

  const setIsEditing = value => dispatch(setIsEditingSpeedFormation(value))
  const changeDate = ({ date: picked }) => {
    const day = pickedDayAsIso(picked)
    if (day === '') {
      return
    }
    dispatch(setSpeedFormationDate(new Date(day).toISOString()))
  }

  const saveSpeedFormation = () => {
    if (!editorRef.current) {
      return
    }
    const text = editorRef.current.getContent()
    const dueDay = savedDate ? savedDate.toISOString().slice(0, 10) : pickedDayAsIso(minDueDate)
    const formattedDate = hasDueDate ? dueDay : null
    dispatch({ type: homeActions.SAVE_SPEED_FORMATION, text, date: formattedDate })
  }

  return {
    speedFormation,
    editorRef,
    pickerDate,
    minDueDate,
    changeDate,
    hasDueDate,
    setIsEditing,
    saveSpeedFormation,
    isLoading,
    error,
    errorMessage,
  }
}

export default useFormationForm
